export default __webpack_public_path__ + "static/media/Comp 2_00019.cba8dbf5.png";